import { bodyEl } from "./elements";
import $ from "jquery";

const createRippleEffect = (event) => {
  const $container = $("<div/>", { class: "ripple-effect-container" });
  const $ripple = $("<div/>", { class: "ripple-effect" });

  const endCoords =
    event.originalEvent.targetTouches && event.originalEvent.targetTouches[0];
  const topPosition = (endCoords ? endCoords.pageY : event.pageY) - 40;
  const leftPosition = (endCoords ? endCoords.pageX : event.pageX) - 40;

  $container.css({ top: topPosition, left: leftPosition });
  $ripple.css({ background: $(event.target).data("ripple-color") });
  $ripple.appendTo($container);
  $container.appendTo(bodyEl);

  setTimeout(remove, 350, $container);
};

function remove(container) {
  container.remove();
}

export function initRipple() {
  $(".ripple").off("click");
  $(".ripple").on("click", createRippleEffect);
}

initRipple();
